module.exports = __webpack_public_path__ + "static/media/MasterTitleHeader.2a014e89.png";